import { useState } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "./ui/dialog";
import { Medical } from "./PlayerFormDialog";

const input = "w-full min-w-0 rounded-lg border border-line bg-ink px-3 py-2 text-sm text-chalk outline-none focus:border-lime";
const lbl = "mb-1 block font-mono text-[11px] uppercase tracking-[0.15em] text-dim";
const FIELDS = [["nom", "Nom *", "text"], ["fonction", "Fonction (ex. : Coach, Délégué 1)", "text"], ["telephone", "Téléphone", "tel"], ["email", "E-mail", "email"]];
const EMPTY = {
  nom: "", fonction: "", telephone: "", email: "", remarques: "", date_naissance: "", adresse: "",
  urgence_choix: "", urgence_lien: "", urgence_nom: "", urgence_adresse: "", urgence_tel: "",
  medecin_nom: "", medecin_adresse: "", medecin_tel: "", medical: "", taille_maillot: "", taille_date: "",
  sante_probleme: "", sante_details: "", traitement: "", traitement_details: "", allergies: "", allergies_details: "",
};

const Field = ({ k, label, f, set, type = "text", className = "" }) => (
  <label className={className}><span className={lbl}>{label}</span>
    <input data-testid={`encadrant-form-${k.replace(/_/g, "-")}`} type={type} value={f[k]} onChange={(e) => set(k)(e.target.value)} className={`${input} ${type === "date" ? "[color-scheme:dark]" : ""}`} />
  </label>
);

const Urgence = ({ f, set }) => (
  <fieldset className="rounded-2xl border border-signal/60 p-3">
    <legend className="px-1 font-display text-lg uppercase text-signal">Contact d'urgence</legend>
    <div className="grid gap-2 sm:grid-cols-2">
      <Field k="urgence_lien" label="Lien (ex. : conjoint, frère)" f={f} set={set} />
      <Field k="urgence_nom" label="Nom" f={f} set={set} />
      <Field k="urgence_tel" label="Téléphone" type="tel" f={f} set={set} />
      <Field k="urgence_adresse" label="Adresse" f={f} set={set} />
    </div>
  </fieldset>
);

export const EncadrantDialog = ({ initial, onClose, onSubmit }) => {
  const [f, setF] = useState({ ...EMPTY, ...(initial ?? {}) });
  const set = (k) => (v) => setF((p) => ({ ...p, [k]: v }));
  const submit = async (e) => {
    e.preventDefault();
    const urgence = [f.urgence_lien, f.urgence_nom, f.urgence_tel, f.urgence_adresse].some((x) => x.trim());
    if (await onSubmit({ ...f, urgence_choix: urgence ? "autre" : "" })) onClose();
  };
  return (
    <Dialog open onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent data-testid="encadrant-form-dialog" className="max-h-[90vh] w-[calc(100%-1.5rem)] max-w-2xl overflow-y-auto rounded-[24px] border-lime/60 bg-pitch text-chalk">
        <DialogHeader>
          <DialogTitle className="font-display text-2xl uppercase text-lime">{initial?.id ? "Modifier l'encadrant" : "Ajouter un encadrant"}</DialogTitle>
          <DialogDescription className="text-dim">L'encadrement apparaît en haut de l'effectif et dans les exports, mais n'est jamais convoqué ni compté dans les présences.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          <div className="grid gap-2 sm:grid-cols-2">
            {FIELDS.map(([k, l, t]) => (
              <label key={k}><span className={lbl}>{l}</span>
                <input data-testid={`encadrant-form-${k}`} type={t} required={k === "nom"} value={f[k]} onChange={(e) => set(k)(e.target.value)} className={input} />
              </label>
            ))}
            <Field k="date_naissance" label="Date de naissance" type="date" f={f} set={set} />
            <Field k="adresse" label="Adresse" f={f} set={set} />
          </div>
          <Urgence f={f} set={set} />
          <Medical f={f} set={set} sante />
          <div className="grid grid-cols-2 gap-2">
            <Field k="taille_maillot" label="Taille maillot" f={f} set={set} />
            <Field k="taille_date" label="Date de la taille" type="date" f={f} set={set} />
          </div>
          <label className="block"><span className={lbl}>Remarques</span>
            <textarea data-testid="encadrant-form-remarques" rows={2} maxLength={500} value={f.remarques} onChange={(e) => set("remarques")(e.target.value)} className={`${input} resize-none`} />
          </label>
          <div className="flex justify-end gap-2">
            <button type="button" data-testid="encadrant-form-cancel" onClick={onClose} className="rounded-full border border-line px-5 py-2 text-sm text-chalk">Annuler</button>
            <button data-testid="encadrant-form-submit" className="rounded-full bg-lime px-5 py-2 text-sm font-semibold text-ink">Enregistrer</button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
